import { get } from './fetch';
import config, { endpoints } from '../configShared';

const csrfTokenCall = () => {
  return get([config.fetchOptions.url, endpoints.csrfToken].join('/'));
};

export default csrfTokenCall;
